import { TELCO } from "constants/common";

const changePhoneNumber = (value) => {
  if (value) {
    if (value.startsWith("+84")) {
      value = "0" + value.substring(3, value.length);
    }
    if (value.startsWith("84")) {
      value = "0" + value.substring(2, value.length);
    }
    return value.replace(/[() -]/g, "");
  }
  return value;
};

const checkPhoneNetwork = (numberPhone, isErrorPhoneNumber) => {
  if (isErrorPhoneNumber) {
    return "";
  }
  const numberPhoneNetwork = changePhoneNumber(numberPhone).substring(0, 3);
  const VT = [
    "086",
    "096",
    "097",
    "098",
    "032",
    "033",
    "034",
    "035",
    "036",
    "037",
    "038",
    "039",
  ];
  const MB = ["089", "090", "093", "070", "079", "077", "076", "078"];
  const VN = ["088", "091", "094", "083", "084", "085", "081", "082", "087"];
  const VNMB = ["092", "052", "056", "058"];

  let networkName = "";

  VT.filter((i) => [numberPhoneNetwork].includes(i)).map((i) => {
    networkName = TELCO[0].value;
    return;
  });
  VN.filter((i) => [numberPhoneNetwork].includes(i)).map((i) => {
    networkName = TELCO[1].value;
    return;
  });
  MB.filter((i) => [numberPhoneNetwork].includes(i)).map((i) => {
    networkName = TELCO[2].value;
    return;
  });
  VNMB.filter((i) => [numberPhoneNetwork].includes(i)).map((i) => {
    networkName = TELCO[3].value;
    return;
  });
  console.log("checkPhoneNetwork: ", networkName);
  return networkName;
};
export default checkPhoneNetwork;
